<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title">
				<template #main>
					<SubHeaderButtons
						:active-route="activeRoute"
						:change-route="changeRoute"
						:label-and-link-name="labelAndLinkName"
					/>
				</template>
			</SubHeader>
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view />
			</Card>
			<div id="banner"></div>
		</ContentBody>
	</div>
</template>

<script>
import SubHeaderButtons from '../../../components/SubHeaderButtons/SubHeaderButtons'
import Card from '../../../components/Card/Card'
import ContentBody from '../../../components/ContentBody/ContentBody'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SubHeader from '../../../components/SubHeader/SubHeader'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader, SubHeaderButtons },
	data() {
		return {
			activeRoute: '',
		}
	},
	computed: {
		title() {
			return `${this.$t('registry')} / ${this.$t('forest')} / ${this.label}`
		},
		label() {
			return this.labelAndLinkName.filter((f) => f.linkName === this.activeRoute)[0].label
		},
		labelAndLinkName() {
			return [
				{ label: this.$t('farm'), linkName: 'fazenda' },
				{ label: this.$t('section'), linkName: 'talhao' },
				{ label: this.$t('plantation'), linkName: 'plantio' },
				{ label: this.$t('species'), linkName: 'especie' },
				{ label: this.$t('geneticMaterial'), linkName: 'materialGenetico' },
				{ label: this.$t('soil'), linkName: 'solo' },
				{ label: this.$t('Imagens'), linkName: 'imagens' },
			]
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},

	methods: {
		changeRoute(linkName) {
			if (this.$router.currentRoute.name !== linkName) {
				this.$router.push({ name: linkName })
				this.activeRoute = linkName
			}
		},
	},
}
</script>

<style scoped></style>
